export default __webpack_public_path__ + "img/f5dd03cc466f2c4c56a9ea581798add9.png";